export const DynamicHeaderMenuConfig = {
  items: [
    {
      title: 'Home',
      root: true,
      alignment: 'left',
      page: '/dashboard',
      translate: 'MENU.DASHBOARD',
    },
    {
      title: 'Polizas',
      root: true,
      alignment: 'left',
      page: '/list-insurance',
    },
    {
      title: 'Documentos',
      root: true,
      alignment: 'left',
      page: '/list-documents',
    },
    {
      title: 'Estados de Cuenta',
      root: true,
      alignment: 'left',
      page: '/account-statements',
    },
    {
      title: 'Pagos',
      root: true,
      alignment: 'left',
      page: '/my-payments',
    },
  ]
};
